import Image, { StaticImageData } from 'next/image';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';
import { useEffect, useRef } from 'react';
import { useOnScreenOnce } from '@app/hooks/useOnScreenOnce';

interface AdSimpleImageProps {
  text?: string;
  href?: string;
  scrollTop?: number;
  image: string | StaticImageData;
  className?: string;
  creativeName?: string;
  promotionId?: string;
  promotionName?: string;
}

export const AdSimpleImage = (props: AdSimpleImageProps) => {
  const ref = useRef(null);
  const isVisible = useOnScreenOnce(ref);

  useEffect(() => {
    if (isVisible) {
      ServiceEcommerce2.promoView([
        {
          creative_name: props.creativeName,
          promotion_id: props.promotionId,
          promotion_name: props.promotionName,
        },
      ]);
    }
  }, [isVisible]);

  const onClick = async () => {
    await ServiceEcommerce2.selectPromotion({
      creative_name: props.creativeName,
      promotion_id: props.promotionId,
      promotion_name: props.promotionName,
    });

    await ServiceEcommerce2.promoClick({
      creative_name: props.creativeName,
      promotion_id: props.promotionId,
      promotion_name: props.promotionName,
    });

    if (props.href) {
      setTimeout(() => window.open(props.href, '_blank'));
    }
  };

  return (
    <div ref={ref}>
      <Image onClick={onClick} src={props.image} width={684} height={451} alt={'Preview'} layout={'responsive'} />
    </div>
  );
};
